import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Import Navigate
import Home from './dashboard/Home';
import FeedbackSession from './dashboard/FeedbackSession';
import MainLayout from './layout/MainLayout';
import Login from './authentication/login/Login';
import SignUp from './authentication/signUp/SignUp';
import PasswordReset from './authentication/passwordReset/PasswordReset';
import SettingsPage from './settings/SettingsPage';
import './App.css';
import { useState, useEffect } from 'react';
import { AuthService } from './services/AuthService'; // Import AuthService

function App() {
  // Initialize state based on simple token presence, validation happens in useEffect
  const [isAuthenticated, setIsAuthenticated] = useState(AuthService.isAuthenticated());

  // Effect to handle auth state changes and validate token on load
  useEffect(() => {
    const checkAuthStatus = async () => {
      const hasToken = AuthService.isAuthenticated();
      if (hasToken) {
        const isValid = await AuthService.validateToken(); // Validate token with backend
        setIsAuthenticated(isValid);
        if (!isValid) {
          // AuthService.validateToken handles logout if token is invalid
          console.log("Token validation failed, user logged out.");
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    // Check on mount
    checkAuthStatus();

    // Listen for storage events (e.g., logout in another tab)
    const handleStorageChange = () => {
        // Re-check authentication status when storage changes
        setIsAuthenticated(AuthService.isAuthenticated());
    };
    window.addEventListener('storage', handleStorageChange);

    // Listen for custom auth change events (e.g., after login/logout)
    const handleAuthChange = () => {
        setIsAuthenticated(AuthService.isAuthenticated());
    };
    window.addEventListener('authChange', handleAuthChange);


    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('authChange', handleAuthChange);
    };
  }, []); // Run only on mount

  // Define a logout handler if needed elsewhere (e.g., in MainLayout)
  const handleLogout = () => {
      AuthService.logout();
      // State update will be triggered by the 'authChange' event listener
  };


  return (
    <Router>
      {isAuthenticated ? (
        <Routes>
          {/* Main application layout for authenticated users */}          <Route path="/" element={<MainLayout />} >
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="dashboard" element={<Home />} />
            <Route path="dashboard/feedback-session/:submissionId" element={<FeedbackSession />} />
            <Route path="settings" element={<SettingsPage />} />
            {/* Add other authenticated routes here */}
          </Route>
          {/* Redirect auth pages to root if already logged in */}
           <Route path="/login" element={<Navigate to="/" replace />} />
           <Route path="/sign-up" element={<Navigate to="/" replace />} />
           <Route path="/password-reset" element={<Navigate to="/" replace />} />
           {/* Optional: Redirect any other unknown authenticated path to root */}
           <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : (
        <Routes>
          {/* Authentication routes for non-authenticated users */}
          <Route path="/" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          {/* Redirect any other path to login if not authenticated */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;